import { typographyTokens } from '../../../theme/typographyTokens';
import React from 'react';
import { Box, Divider, Stack, Typography, useTheme } from '@mui/material';
import HoveredIconConfirm from '../HoveredIconConfirmButton';

import { useDeleteDataFieldOptionTemplateMutation } from '../../../services/dataFieldsSlice';

const DataFieldOptionCard = ({ datafieldOption, index }: any) => {
  const [deleteDataFieldOption] = useDeleteDataFieldOptionTemplateMutation();

  const handleDeleteOption = () => {
    deleteDataFieldOption(datafieldOption.id);
  };

  const theme = useTheme();

  return (
    <>
      <Box
        sx={{
          backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.default : '#F8F9FA',
          padding: '16px 40px 16px 45px',
          boxShadow:'0.5px 0.5px 0.5px 0.5px #9c9c9c',border: '0.5px solid #888888',marginBottom:'7px'
        }}
      >
        <Stack
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
        >
          <Box>
            <Stack display="flex" flexDirection="row" alignItems="center">
              <Typography
                component="span"
                sx={{
                  color: '#646669',
                  fontSize: typographyTokens.fontSizes.caption,
                  fontWeight: typographyTokens.fontWeights.bold,
                }}
              >
                {`Option ${index + 1}`}
              </Typography>
              &nbsp;&nbsp;
            </Stack>
            <Typography
              component="span"
              sx={{
                fontSize: typographyTokens.fontSizes.body,
                fontWeight: typographyTokens.fontWeights.bold,
              }}
            >
              {datafieldOption.value}
            </Typography>
          </Box>
          <Stack
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            sx={{
              width: '40px',
            }}
          >
            <HoveredIconConfirm
              icon="fa-regular fa-trash"
              hoverIcon="fa-solid fa-trash"
              onClick={() => handleDeleteOption()}
            />
          </Stack>
        </Stack>
      </Box>
      <Divider />
    </>
  );
};

export default DataFieldOptionCard;
